import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import {
    ICalculatorData,
    ICalculatorExitObj,
    ICalculatorInitObj, ICalculatorTranlsation
} from '../../shared/interfaces/calculator.interface';
import { IProjectAccessRights } from '../../shared/interfaces/projects.Interfaces';
import { Enums } from '../../shared/models/enums';

@Injectable()
export class gblCalculatorCommonService {
  modalRef: MDBModalRef;
  confirmationStatus = Enums.confirmationStatus;

  private gblCallbackCalcModalClose = new Subject<ICalculatorExitObj>(); // Source
  eventCallbackCalcModalClose$ = this.gblCallbackCalcModalClose.asObservable(); // Stream

  toolName: string;
  projectID: string;
  selectedProjectStage: string;
  section: string;
  measureId: string;
  projectAccess: IProjectAccessRights;
  heading: string;

  calculatorData: ICalculatorData;
  calculatorInitObj: ICalculatorInitObj;  
  calculatorStaticText: any;
  calculatorTranlsations: Array<ICalculatorTranlsation> = [];
  resetCalculator = false;
  isGBLCalculatorVisible = false;
  calculatorModalComponent: any;
}
